import React from 'react';

import classes from './HelpDrawer.module.css';
import Row from "react-bootstrap/Row";
import Container from "react-bootstrap/Container";
import Col from "react-bootstrap/Col";

const helpDrawer = (props ) => {
    // let attachedClasses = [classes.HelpDrawer, classes.Close];
    // if (props.open) {
    //     attachedClasses = [classes.HelpDrawer, classes.Open];
    // }
    return (
        // <Aux>
        //     <Backdrop show={props.open} clicked={props.closed}/>
        //     <div className={attachedClasses.join(' ')}>
                <section className={classes.Notice}>
                    <div className="card" style={{width: "100%", height: "100%",}}>
                        <h4 className={"card-header "+classes.NoticeHeader}>Welcome to the Pattern Library from Pattern Language for Game Design!</h4>
                        <div className={"card-body " + classes.NoticeContent}>

                            <Container fluid>
                                <Row xs={1} md={2} lg={2} xl={2} >
                                    <Col  key="0">
                                        <b>You can use this website to:</b>
                                        <ul>
                                            <li>Browse useful game design patterns.</li>
                                            <li>Search for patterns to use as a Pattern Language in the practical design of your game.</li>
                                            <li>Visit the Games Reference to learn more about the games used as examples in the patterns.</li>
                                            <li>Create an account, so you can:
                                                <ul>
                                                    <li>Add your own patterns as you work through the exercises in the book.</li>
                                                    <li>Add new games to the Games Reference.</li>
                                                    <li>Create or join a group for your team, class or studio to build a Pattern Language together.</li>
                                                </ul>
                                            </li>
                                        </ul>
                                    </Col>

                                    <Col  key="1">
                                        <b>For more detail and help using this site, refer to these articles:</b>
                                        <ul>
                                            <li><a href="https://perspectivesingamedesign.com/what-is-the-pattern-library-f9d6211d2db8" target="_blank" rel="noopener noreferrer">
                                                Welcome/What is the Pattern Library</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/how-to-use-the-pattern-library-to-view-and-find-patterns-533800478692" target="_blank" rel="noopener noreferrer">
                                                How to use the Pattern Library to view and find patterns</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/how-to-use-the-game-reference-to-find-and-learn-about-games-e2a78c05b772" target="_blank" rel="noopener noreferrer">
                                                How to use the Game Reference to find and learn about games</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/how-to-register-an-account-fill-out-a-profile-and-join-manage-groups-be793c1b6737" target="_blank" rel="noopener noreferrer">
                                                How to register an account and fill out a profile/join/manage groups</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/how-to-create-a-pattern-43742ad024f9" target="_blank" rel="noopener noreferrer">
                                                How to create a pattern</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/confidence-rubrics-for-patterns-and-pattern-relationships-7c9162e3672d" target="_blank" rel="noopener noreferrer">
                                                Pattern and Link Confidence</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/how-to-enter-a-game-61375a0c5f5" target="_blank" rel="noopener noreferrer">
                                                How to enter a game</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/how-to-get-help-with-the-pattern-library-website-8e4a8899b179" target="_blank" rel="noopener noreferrer">
                                                How to request help</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/whats-next-dfd606744fee" target="_blank" rel="noopener noreferrer">
                                                What's Next?</a></li>
                                            <li><a href="https://perspectivesingamedesign.com/pattern-library-usage-agreement-769d20a27c5c" target="_blank" rel="noopener noreferrer">
                                                Pattern Library Usage Agreement</a></li>
                                        </ul>
                                    </Col>
                                </Row>
                            </Container>
                        </div>
                {/*        <Button className={classes.CancelButton} onClick={props.closed}>Close</Button>*/}
                    </div>

                </section>

        //     </div>
        // </Aux>
    );
};

export default helpDrawer;